module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_7016.f580b910.png";